import React from 'react'
import { DataTable, TreeviewDropdown } from '../../CommonComponent'
import { Iprops } from './dealeravailabilityinterface';
import dealeravailability from './dealeravailability.json'
import './dealeravailability.scss'

function Dealeravailability(props:Iprops) {

    const orderingbranch = [
        { value: "PC200-8", title: "PC200-8" },
        { value: "SAA6D140E-5F", title: "SAA6D140E-5F" }
    ];

    const DetailComponent = () => {
        return (
          <div className="nestedparent_grid">
            <DataTable
              data={dealeravailability[0].data}
              dataColumn={props.Nestedcolumns}
              reorderable={true}
            />
          </div>
        )
      }

    return (
        <div className="dealeravailability_wrapper">
            <div className="dealeravailability_heading mb-2">
                <span className="dealeravailability_title mr-2">Ordering Branch</span><span className='fa fa-info-circle'></span>
            </div>
            <div>
                <TreeviewDropdown
                    treeData={orderingbranch}
                    showSearch={false}
                />
            </div>
            <div className="dealeravailability_text mt-1">
                Changing ordering branch will affect all the items in the cart. You can have only one ordering branch for a cart
            </div>
            <div className='orderingbranchgrid mt-3'>
                <DataTable
                    data={dealeravailability[0].data}
                    dataColumn={props.columns}
                    reorderable={true}
                    DetailComponent={DetailComponent}
                    DetailRow={true}
                />
            </div>
        </div>
    )
}

export default Dealeravailability